import axios from "@/libs/api.request";
import { getToken } from "@/libs/util";
// 获取理赔池列表
export const getClaimList = params => {
  return axios.request({
    url: "/finance/ClaimPond",
    method: "get",
    params
  });
};
// 新增理赔池
export const addClaim = data => {
  return axios.request({
    url: "/finance/ClaimPond",
    method: "post",
    data
  });
};

// 编辑理赔池
export const editClaim = data => {
  return axios.request({
    url: "/finance/ClaimPond/" + data.id,
    method: "put",
    data
  });
};

// 删除理赔池
export const deleteClaim = data => {
  return axios.request({
    url: "/finance/ClaimPond/" + data.id,
    method: "DELETE",
    data
  });
};
